import { render, staticRenderFns } from "./RatingNavigationDrawer.vue?vue&type=template&id=73e2458a"
import script from "./RatingNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./RatingNavigationDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports